import React from 'react'
import { ActionMenu } from 'oolib';

export const AudioAction = ({id, inputRef, parentOnChange, isInRTE}) => (
    <div style={{ ...(isInRTE ? { display: "none" } : {}) }}> 
      <ActionMenu
        popOutOfOverflowHiddenParent
        ButtonComp={"ButtonGhost"}
        M
        actions={[
          {
            id: `${id}_reuploadAudio`,
            display: "Replace Audio",
            onClick: () => {
              inputRef.current.click();
            },
          },
          {
            display: "Delete",
            onClick: () => parentOnChange(undefined),
          },
        ]}
      />
    </div>
);
